// Input types
export const TEXT = 'text';
export const SELECT = 'select';
export const MULTISELECT = 'multiselect';
export const RADIO = 'radio';
export const CHECKBOX = 'checkbox';
export const DATE = 'date';
export const HIDDEN = 'hidden';
